import { FormSelect, EnumValueDisplay, FormTextField } from '@lib/common';
import { Grid, MenuItem } from '@material-ui/core';
import { FilterSection } from 'app/shared';
import { DeviceType, GetThingsRequest, LocationType, PowerStatus } from 'app/state';
import React, { useEffect } from 'react';
import { useForm, FormContext } from 'react-hook-form';

export interface DeviceFilters extends GetThingsRequest {}

interface Props {
  onChange: (filters: DeviceFilters) => void;
}

export function DeviceFilterForm({ onChange }: Props) {
  const form = useForm<DeviceFilters>();

  const { thingIdentifier, thingLocationType, thingType, thingStatus } = form.watch({ nest: true });

  useEffect(() => {
    if (onChange !== null)
      onChange({
        thingIdentifier,
        thingLocationType,
        thingType,
        thingStatus,
      });
  }, [onChange, thingIdentifier, thingLocationType, thingType, thingStatus]);

  return (
    <FilterSection>
      <FormContext {...form}>
        <Grid container spacing={2} style={{ padding: '0 1rem 1rem 1rem', marginTop: '1rem' }}>
          <Grid item md={3} xs={6}>
            <FormTextField name="thingIdentifier" label="Area/Room Name" fullWidth />
          </Grid>
          <Grid item md={3} xs={6}>
            <FormSelect name="thingType" label="Device Type" defaultValue="" fullWidth>
              <MenuItem key="any" value="">
                All
              </MenuItem>
              {Object.keys(DeviceType).map(t => (
                <MenuItem key={t} value={t}>
                  <EnumValueDisplay value={t} />
                </MenuItem>
              ))}
            </FormSelect>
          </Grid>
          <Grid item md={3} xs={6}>
            <FormSelect name="thingStatus" label="Device Status" defaultValue="" fullWidth>
              <MenuItem key="any" value="">
                All
              </MenuItem>
              {Object.keys(PowerStatus).map(s => (
                <MenuItem key={s} value={s}>
                  <EnumValueDisplay value={s} />
                </MenuItem>
              ))}
            </FormSelect>
          </Grid>
          <Grid item md={3} xs={6}>
            <FormSelect name="thingLocationType" label="Location" fullWidth defaultValue="">
              <MenuItem key="any" value="">
                All
              </MenuItem>
              {Object.keys(LocationType).map(s => (
                <MenuItem key={s} value={s}>
                  <EnumValueDisplay value={s} />
                </MenuItem>
              ))}
            </FormSelect>
          </Grid>
        </Grid>
      </FormContext>
    </FilterSection>
  );
}
